import axios from 'axios'
import { COMMISSIONS_ENDPOINT } from '../../endpoints'

export async function createComissionPolicy(body) {
  const response = await axios.post(
    `${COMMISSIONS_ENDPOINT}/createComissionPolicy`,
    body
  )
  
  return response.data
}
